import {
  formatPromotionEventTime,
  formatUtcEventDate,
} from "./promotionEventDateTime";

const EXPORT_PAGE_SIZE = 200;
const EXPORT_MAX_PAGES = 50;

export const escapeCsvCell = (value) => {
  const str = String(value ?? "");
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const formatUtcCsvDate = (iso) => {
  const label = formatUtcEventDate(iso, { shortYear: true });
  return label === "—" ? "" : label;
};

/** @deprecated Prefer formatUtcCsvDate */
export const csvDisplayDate = formatUtcCsvDate;

export const csvDisplayTime = (iso) =>
  formatPromotionEventTime(iso, { empty: "" });

export const toCsvContent = (rows = []) => {
  const headers = rows[0] ? Object.keys(rows[0]) : [];
  const lines = [
    headers.map(escapeCsvCell).join(","),
    ...rows.map((row) =>
      headers.map((key) => escapeCsvCell(row[key])).join(",")
    ),
  ];
  return `\uFEFF${lines.join("\n")}`;
};

export const downloadCsvFile = (rows, filename) => {
  const blob = new Blob([toCsvContent(rows)], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    filename.endsWith(".csv") ? filename : `${filename}.csv`
  );
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const collectPaginatedList = async (fetchPage, readPage) => {
  let page = 1;
  let items = [];
  let totalPages = 1;
  do {
    const result = await fetchPage(page, EXPORT_PAGE_SIZE);
    const { list = [], pages = 1 } = readPage(result) || {};
    items = items.concat(list);
    totalPages = Math.max(1, pages || 1);
    page += 1;
  } while (page <= totalPages && page <= EXPORT_MAX_PAGES);
  return items;
};

export const mapPromotionEligibilityToCsv = (rows = []) =>
  rows.map((row) => ({
    Employee: row.employee?.name || "",
    Email: row.employee?.email || "",
    Company: row.company?.name || "",
    Book: row.book?.name || "",
    "Completed On": formatUtcCsvDate(row.completedOn),
    Status: row.statusLabel || row.status || "",
    "Contacted On": formatUtcCsvDate(row.contactedOn),
    "Responded On": formatUtcCsvDate(row.respondedOn),
    "Promotion Completed": formatUtcCsvDate(row.promotionCompletedOn),
  }));

/** Slim Create Events export (CONTACT_PENDING roster). */
export const mapCreateEventEligibilityToCsv = (rows = []) =>
  rows.map((row) => ({
    Employee: row.employee?.name || "",
    Email: row.employee?.email || "",
    Company: row.company?.name || "",
    Book: row.book?.name || "",
    "Completed On": formatUtcCsvDate(row.completedOn),
  }));

export const mapPromotionEventsToCsv = (rows = [], { includeStatus = false } = {}) =>
  rows.map((row) => ({
    "Promotion Name": row.name || "",
    "Book Name": row.book?.name || "",
    "Created By": row.createdBy?.name || "",
    "Created On": formatUtcCsvDate(row.createdOn),
    "Promotion Date": formatUtcCsvDate(row.eventDate),
    "Promotion Time":
      row.hasEventTime === false ? "" : csvDisplayTime(row.eventDate),
    "Promotion Venue": row.venue || "",
    ...(includeStatus
      ? { "Promotion Status": row.statusLabel || row.status || "" }
      : {}),
    "Event ID": row.eventId || "",
    Employees: row.employeeCount ?? 0,
  }));

export const mapEventEmployeesToCsv = (rows = []) =>
  rows.map((row) => ({
    Employee: row.employee?.name || "",
    Email: row.employee?.email || "",
    Company: row.company?.name || "",
    "Completed On": formatUtcCsvDate(row.completedOn),
    Status: row.statusLabel || row.status || "",
    "Contacted On": formatUtcCsvDate(row.contactedOn),
    "Responded On": formatUtcCsvDate(row.respondedOn),
    "Rejection Reason": row.rejectionReason || "",
  }));
